import { useState } from 'react';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './CustomerV2.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import OrdersList from '../../components/OrdersList/OrdersList';

const CustomerV2 = () => {
    const [customer, setCustomer] = useState(null);
    const params = useParams();

    const navigate = useNavigate();

    useEffect(() => {
        if (params.id) {
            getCustomer(params.id);
        } else {
            navigate('/');
        }
    }, [params])

    const getCustomer = (id) => {
        fetch(`${process.env.REACT_APP_API}/api/getCustomer/${id}`, {})
        .then(response => {
            if (response.status === 200) {
                response.json().then(data => setCustomer(data));
            }
        })
    }

    return (
        <div className="v2-page customerv2">
            <NavbarV2 />

            <div className="v2-container">
                <h1 className="v2-h1">{customer ? customer.name : 'Customer'}</h1>
                {customer && (
                    <>
                        <div className="customerv2-chip">
                            <span className="customerv2-chip-label">VAT</span>
                            <span>{customer.VAT}</span>
                        </div>
                        <div className="v2-mui-scope customerv2-mui">
                            {customer.orders.length > 0 ? (
                                <OrdersList data={customer.orders} />
                            ) : (
                                <div className="v2-card customerv2-empty">
                                    <p className="v2-muted">No orders on file for this account.</p>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default CustomerV2;